import type { UseQueryResult } from "@tanstack/react-query";
import { clsx } from "clsx";

import type { Airport as AirportType } from "@jb-dotcom/api/odb/transformed";
import { FieldError } from "@jetblue/kit/field-error";
import { InputCity } from "@jb-dotcom/dotcom-components/input-city";
import { SwapButton } from "@jb-dotcom/dotcom-components/swap-button";

type InputRouteLabels = {
  destination: string;
  errors: {
    destination: string;
    origin: string;
  };
  origin: string;
  swap: string;
};

export type InputRouteProperties = {
  className?: string;
  destination: string | undefined;
  destinationIsRequired?: boolean | undefined;
  destinationName?: string | undefined;
  labels: InputRouteLabels;
  odRouteData: {
    destination: NonNullable<UseQueryResult<AirportType[]>>["data"];
    origin: NonNullable<UseQueryResult<AirportType[]>>["data"];
  };
  onDestinationChange: (destination: string) => void;
  onOriginChange: (origin: string) => void;
  onSwapClick: () => void;
  origin: string | undefined;
  originIsRequired?: boolean | undefined;
  originName?: string | undefined;
  showValidation?: boolean | undefined;
};
export const InputRoute = ({
  className,
  destination,
  destinationIsRequired,
  destinationName,
  labels,
  odRouteData,
  onDestinationChange,
  onOriginChange,
  onSwapClick,
  origin,
  originIsRequired,
  originName,
  showValidation = false,
}: InputRouteProperties) => (
  <div className={clsx("isolate flex flex-row", className)}>
    <InputCity
      error={
        <FieldError>
          {({ isInvalid }) => (isInvalid ? labels.errors.origin : null)}
        </FieldError>
      }
      inputValue={origin}
      isRequired={originIsRequired}
      label={labels.origin}
      name={originName}
      odData={odRouteData.origin}
      onInputChange={onOriginChange}
      showValidation={showValidation}
    />

    <SwapButton label={labels.swap} onClick={onSwapClick} />

    <InputCity
      error={
        <FieldError>
          {({ isInvalid }) => (isInvalid ? labels.errors.destination : null)}
        </FieldError>
      }
      inputValue={destination}
      isRequired={destinationIsRequired}
      label={labels.destination}
      name={destinationName}
      odData={odRouteData.destination}
      onInputChange={onDestinationChange}
      showValidation={showValidation}
    />
  </div>
);
